module.exports = __webpack_public_path__ + "img/zhengshu4.1014633b.png";